import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { startUserSessionMonitor } from '../../shared/utitlity-functions/utility-functions';

@Component({
    selector: 'octo-incomplete-and-contact-support',
    standalone: true,
    imports: [],
    templateUrl: './incomplete-and-contact-support.component.html',
    styleUrls: ['./incomplete-and-contact-support.component.scss'],
})
export class IncompleteAndContactSupportComponent implements OnInit {
    ngOnInit(): void {
        startUserSessionMonitor();
    }
}
